<ion-card>
  <div class="event-banner">
    <ion-img [src]="eventItem?.img" alt="" srcset=""></ion-img>
    <div *ngIf="eventItem?.tag" class="price-tag">{{eventItem?.tags}}</div>
  </div>
  <div class="event-card-content">
    <ion-card-header>
      <ion-card-title>{{eventItem.title}}</ion-card-title>
      <ion-card-subtitle>
        <!-- <ion-label>
          <ion-icon slot="start" name="location-outline"></ion-icon>
          {{eventItem.location}}
        </ion-label> -->
      </ion-card-subtitle>
      <!-- <div class="price mart10">
        <b>&#8377; {{eventItem.finalPrice}}</b>
        <ion-text color="success marl4">
          <span>(30% off)</span>
        </ion-text>
      </div> -->
    </ion-card-header>
    <ion-button class="ion-margin" routerLink="/event/{{eventItem.serviceid}}" routerDirection="forward">
      View
    </ion-button>
  </div>
</ion-card>